import Vue from 'vue'
import Router from 'vue-router'
import VuePageTransition from "vue-page-transition";

// pages
import Start from "@/pages/Start"
import Top from '@/pages/Top'
import Login from '@/pages/LoginPage'
import Home from '@/pages/Home'
import RecordMeals from '@/pages/RecordMeals'
import History from '@/pages/History'
import Other from '@/pages/Other'
import AccountCreate from '@/pages/AccountCreate'
import FrailtyRiskCheck from '@/pages/FrailtyRiskCheck'
import WeeklyTable from '@/pages/WeeklyTable'
import WaterWeeklyBar from "@/pages/WaterWeeklyBar";

Vue.use(Router)
Vue.use(VuePageTransition);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "Start",
      component: Start,
    },
    {
      path: "/top",
      name: "Top",
      component: Top,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/recordMeals",
      name: "RecordMeals",
      component: RecordMeals,
    },
    {
      path: "/history",
      name: "History",
      component: History,
      props: true
    },
    {
      path: "/accountCreate",
      name: "AccountCreate",
      component: AccountCreate,
    },
    {
      path: "/other",
      name: "Other",
      component: Other,
    },
    {
      path: "/frailtyRiskCheck",
      name: FrailtyRiskCheck,
      component: FrailtyRiskCheck,
    },
    {
      path: "/WeeklyTable",
      name: "WeeklyTable",
      component: WeeklyTable,
    },
    {
      path: "/WaterWeeklyBar",
      name: "WaterWeeklyBar",
      component: WaterWeeklyBar,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js